import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../../../redux/actions/modals";
import { State } from "../../../redux/reducers/root";
import Button from "../button";
import ModalTemplate from "./template";

const Algorithm = () => {
  const modalData = useSelector((state: State) => state.modals);
  const title = modalData.data?.title;
  const score = modalData.data?.score;
  const status = modalData.data?.status;
  const modalDescription = modalData.data?.modalDescription;
  const dispatch = useDispatch();
  const hide = () => {
    dispatch(hideModal());
  };
  return (
    <ModalTemplate title={title} icon="far fa-star" containerClass="mb-4">
      <div className="flex mb-2 text-sm font-bold text-pkc-description-text">
        <span className="ml-2">وضعیت:</span>
        <span>{status}</span>
      </div>
      <div
        className={`w-full h-2 mb-3 rounded-full ${
          score <= 40 ? "bg-pkc-coral-15" : score > 40 && score <= 80 ? "bg-pkc-light-pink" : "bg-pkc-primary-15"
        } `}
      >
        <div
          style={{ width: `${score}%` }}
          className={`h-full text-xs text-center text-white  ${
            score <= 40 ? "bg-pkc-coral" : score > 40 && score <= 80 ? "bg-pkc-orange-yellow" : "bg-pkc-primary"
          } rounded-full`}
        ></div>
      </div>
      <div className="mb-4 text-sm leading-8">
        <p>{modalDescription[0]}</p>
        <p>{modalDescription[1]}</p>
      </div>
      <Button className="w-full" onClick={hide}>
        متوجه شدم
      </Button>
    </ModalTemplate>
  );
};

export default Algorithm;
